/**
 * 登録のステップ
 */
export const REGISTRATION_STEP = {
  first: 1,
  second: 2,
} as const;

/**
 * 登録のステップのコード値
 */
export type RegistrationStep =
  typeof REGISTRATION_STEP[keyof typeof REGISTRATION_STEP];
